import { render, staticRenderFns } from "./AnonUserForm.vue?vue&type=template&id=effa9ea2&"
import script from "./AnonUserForm.vue?vue&type=script&lang=js&"
export * from "./AnonUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports